<template>
  <div class="main">
    <span>
      <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <b-form v-if="operationSelected" class="b-layout equip">
        <b-card v-if="equipments.length > 0">
          <div v-for="(prop, index) in equipments" :key="prop.caption + index">
            <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
            </b-form-checkbox>
          </div>
        </b-card>
        <div v-else>
          <b-card v-if="!this.node.readOnly" >
              <label class="noOperationfield">{{ $t('operacao-sem-equipamentos') }}</label>
          </b-card>
        </div>
        <div class="ml-3">
          <b-card>
            <div class="inp" v-if="!CalcRefluxo.value">
              <label>{{ $t('refluxo-da-coluna-b') }} </label>
              <input
                v-model="RefB.value"
                min="0"
                max="100"
                step="0.1"
                type="number"
              />
            </div>
            <div class="inp" v-else>
              <label>{{ $t('refluxo-sugerido') }} </label>
              <label>{{ Sugestao ? (Sugestao.value | ParseNumber): "0,00" }}</label>
            </div>
            <div class="inp">
              <label>{{ $t('capacidade-de-producao-m-dia') }} </label>
              <label>{{ CapProducao.value | ParseNumber }}</label>
            </div>
            <div class="inp">
              <label>{{ $t('ocupacao-0') }} </label>
              <label>{{ Ocupacao.value | ParseNumber }}</label>
            </div>
          </b-card>
        </div>
      </b-form>
      <b-form-checkbox
        v-if="operationSelected"
        :key="CalcRefluxo.caption"
        class="switch-item ml-3"
        v-model="CalcRefluxo.value"
        switch
      >
        {{ $t('utilizar-refluxo-sugerido') }} </b-form-checkbox>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2 ml-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout equip">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('capacidade-de-producao-m-dia-0') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { FiltersMixin } from "../../../mixins/filtersMixin";
import {  NumberFormat, ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin'
import TextToInput from "../../../template/TextToInput"
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },

  mixins: [FiltersMixin, JokerEquipmentMixin],

  data() {
    return {
      attrList: [
        "RefB",
        "CalcRefluxo",
        "Sugestao",
        "CapProducao",
        "Ocupacao",
      ],
      RefB: {},
      Sugestao: null,
      CapProducao: 0,
      Ocupacao: null,
      CalcRefluxo: null,
      equipCap: [],
      operations: [{ value: null, text:SingletonInter.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      temp: null,
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();
      this.buildJokerEquipment(value)

      this.operationAttributeList = SingletonEnginnering.getOperationsProperties( this.operationSelected )
        .filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (attrName == "CalcRefluxo") {
          this[attrName].value = parseInt(this[attrName].value) ? true : false;
        } else if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
      this.updateNode();
    },

    "RefB.value"() {
      this.updateNode();
    },

    "CalcRefluxo.value"(value){
      if (value) {
        this.RefB.value = this.Sugestao ? this.Sugestao.value : 0;
      }
      this.updateNode();
    }
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
        this.loadNotInput();
      }

      this.equipments = new Array();

      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          let prop = p.clone();
          if (p.caption == "CalcRefluxo") {
            prop.value = parseInt(prop.value) ? true : false;
          } else {
            prop.value = ParseToNumber(prop.value);
          }
          this[p.caption] = prop;
        }

        if (p.equipName) {
          let equip = p.clone();
          equip.value = parseInt(equip.value) ? true : false;

          this.equipments.push(equip);
        }
      });
      this.loadEquipments();
    },

    updateNode() {
      if(this.firstLoad) return

      let propRefB = this.RefB.clone()

      let calRefluxo = this.CalcRefluxo.clone();
      calRefluxo.value = this.CalcRefluxo.value ? "1.00" : "0,00";
      
      if (this.CalcRefluxo.value) {
        this.RefB.value = this.Sugestao ? this.Sugestao.value : 0;
        let propRefB = this.RefB.clone()
        propRefB.value = NumberFormat(this.RefB.value)
      }

      let attrs = [propRefB, calRefluxo];

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });
      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    loadNotInput() {
      this.operationAttributeList = SingletonEnginnering.getOperationsProperties( this.operationSelected).filter((operation) => 
        this.attrList.includes(operation.key)
      );
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });

      this.equipments = auxEquipment;
    },

    ChangeCapacidade() {
      if (this.CapProducao) {
        this.CapProducao.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap)
            this.CapProducao.value += parseFloat(
              String(cap.value).replace(",", ".")
           );
        });
      }
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.updateNode();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)

    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/TB/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.changeExternalCapacity = function () { this.ChangeCapacidade() }
    this.updataNodeInMixin = function () { this.updateNode() }
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.main,
.b-layout {
  display: flex;
  justify-content: space-between;
}

.equip div {
  min-width: 155px;
}

input {
  margin-left: 5px;
  text-align: right;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>